import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LockProvider, useLock } from "./context/LockContext";
import Layout from "./components/Layout";
import Setup from "./pages/Setup";
import LockScreen from "./pages/LockScreen";
import Dashboard from "./pages/Dashboard";
import Expenses from "./pages/Expenses";
import Debt from "./pages/Debt";
import Wealth from "./pages/Wealth";
import Settings from "./pages/Settings";
import { Toaster } from "sonner";

function Gate() {
  const { status } = useLock();
  const [settingUp, setSettingUp] = useState(false);

  if (status === "loading") return null;
  if (status === "setup" || settingUp) {
    return <Setup onStart={() => setSettingUp(true)} onDone={() => setSettingUp(false)} />;
  }
  if (status === "locked") return <LockScreen />;

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="debt" element={<Debt />} />
        <Route path="wealth" element={<Wealth />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LockProvider>
          <Toaster position="top-center" richColors />
          <Gate />
        </LockProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
